import { Pipe, PipeTransform } from '@angular/core';
import { Observable } from 'rxjs';

import { BillingFrequency, Currency } from './display.price';
import { DisplayPriceService } from './display-price.service';

@Pipe({
  name: 'price$',
  standalone: false,
})
export class DisplayPricePipe implements PipeTransform {
  constructor(private displayPriceService: DisplayPriceService) {}
  transform(
    value: any,
    currency: Currency | string,
    billingFrequency?: BillingFrequency,
    isCents = true,
    translateZero = true,
    displaySymbol = true,
    isStartingPrice = false,
  ): Observable<string> {
    return this.displayPriceService.formatDisplayPrice(
      value,
      currency,
      billingFrequency,
      isCents,
      translateZero,
      displaySymbol,
      isStartingPrice,
    );
  }
}

@Pipe({
  name: 'billingFrequency$',
  standalone: false,
})
export class BillingFrequencyPipe implements PipeTransform {
  constructor(private displayPriceService: DisplayPriceService) {}
  transform(frequency: string, price?: string): Observable<string> {
    return this.displayPriceService.formatBillingFrequency(frequency, price);
  }
}
